@if(appearance === "default") {
    @if (success) {
        <div class="copyButton" [class.success]="success" (click)="copyVal()">
            <div class="copyButtonLabel">Copied</div>
        </div>

    }
    @else {
        <div class="copyButton" [class.success]="success" (click)="copyVal()">
            <div class="copyButtonLabel">{{label}}</div>
        </div>
    }
}
@else if (appearance === "compact") {
    @if (success) {
        <img class="copyButtonIcon" src="./image/success.png" (click)="copyVal()" />
    }
    @else {
        <img title="{{label}}" class="copyButtonIcon" src="./image/copy.png" (click)="copyVal()" />
    }
}
